import { Note } from '@/components/common/note'
import { InfoIcon } from '@/components/icons/info'

export const AeraExceptionNote = () => {
  return (
    <Note>
      <div className="flex items-center gap-2">
        <InfoIcon />
        <h6 className="font-bold">Interaction note</h6>
      </div>
      <p className="text-xs">
        Supply and redemptions requests to this vault are typically filled within minutes by the vault’s Guardian.
        <br />
        If your request is not fulfilled within 24 hours, your funds will be automatically returned to it's origin.
      </p>
    </Note>
  )
}
